import React from 'react';
export function DashboardShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15522">
      <span className="sr-only" data-id="element-15523">Loading dashboard…</span>
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-15524">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15525">
            <div className="flex justify-between items-start mb-4" data-id="element-15526">
              <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15527" />
              <div className="w-10 h-10 bg-gray-200 rounded-md" data-id="element-15528" />
            </div>
            <div className="h-8 w-40 bg-gray-200 rounded mb-2" data-id="element-15529" />
            <div className="h-3 w-24 bg-gray-200 rounded" data-id="element-15530" />
          </div>)}
      </div>
      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-15531">
        {[1, 2].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15532">
            <div className="flex justify-between items-center mb-4" data-id="element-15533">
              <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-15534" />
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15535" />
            </div>
            <div className="h-64 bg-gray-200 rounded-md" data-id="element-15536" />
          </div>)}
      </div>
      {/* Activity Section */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15537">
        <div className="h-5 w-40 bg-gray-200 rounded mb-4" data-id="element-15538" />
        <div className="space-y-3" data-id="element-15539">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="flex items-center gap-4 p-3 border border-gray-200 rounded-lg" data-id="element-15540">
              <div className="w-10 h-10 bg-gray-200 rounded-full" data-id="element-15541" />
              <div className="flex-1 space-y-2" data-id="element-15542">
                <div className="h-4 w-64 bg-gray-200 rounded" data-id="element-15543" />
                <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-15544" />
              </div>
              <div className="h-4 w-20 bg-gray-200 rounded" data-id="element-15545" />
            </div>)}
        </div>
      </div>
    </div>;
}